import { render, staticRenderFns } from "./AdminTravelServiceItemEdit.vue?vue&type=template&id=2de71f0d&"
import script from "./AdminTravelServiceItemEdit.vue?vue&type=script&lang=js&"
export * from "./AdminTravelServiceItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminTravelServiceItemEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCheckbox,VCol,VForm,VIcon,VRow,VSpacer,VTab,VTabItem,VTabs,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de71f0d')) {
      api.createRecord('2de71f0d', component.options)
    } else {
      api.reload('2de71f0d', component.options)
    }
    module.hot.accept("./AdminTravelServiceItemEdit.vue?vue&type=template&id=2de71f0d&", function () {
      api.rerender('2de71f0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/AdminTravelServiceItemEdit.vue"
export default component.exports